import React, { useEffect, useRef } from "react";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Th with dynamic content
 * @param {String} id: td identifier (optional)
 * @param {String} tableId: Identifier for the table (required)
 * @param {JSX.Element} children: Text or JSX element (required)
 * @param {String} classes: Extra classNames for <th> (optional)
 * @param {Boolean} fixedXY: Fix the <th> in X and Y (optional)
 * @param {Integer} left: If fixed, the left position for the <th> (optional)
 * @param {React.RefObject} headRef - Optional external ref to access the DOM node of the <th>
 * @param {String} [customWidth=""] - Optional custom width (pixels) class suffix (e.g., `lg` → `custom-width-200`).
 * @returns {JSX.Element}
 */
const CustomTh = ({id, tableId, children, classes, fixedXY=false, left=0, headRef=null, customWidth=""}) => {
    const elementRef = useRef(null);
    const headerOffset = useRef(0);
    const originalLeft = useRef(0);

    useEffect(() => {

        if (elementRef.current) {
            headerOffset.current = elementRef.current.offsetTop;
            originalLeft.current = elementRef.current.getBoundingClientRect().left;
            if (headRef)  headRef.current = elementRef.current;
        }

        const handleScroll = () => {
            if (elementRef.current) {
                let table = document.getElementById(`${tableId}`);
                if (!table) return;

                if (table.scrollTop > headerOffset.current || table.scrollLeft > 0) {
                    elementRef.current.style.position = "sticky";
                    elementRef.current.style.top = "0";

                    if(fixedXY){
                        elementRef.current.style.zIndex = "3";
                        elementRef.current.style.left = left+"px";
                    }else{
                        elementRef.current.style.zIndex = "2";
                    }
                } else {
                    elementRef.current.style.removeProperty("position");
                    elementRef.current.style.removeProperty("top");
                    elementRef.current.style.removeProperty("left");
                    elementRef.current.style.removeProperty("z-index");
                }

            }
        };

        // Applied on mount too: the header can mount while the table is already scrolled //
        handleScroll();

        let table = document.getElementById(`${tableId}`);
        if(table) table.addEventListener("scroll", handleScroll);

        return () => {
            if(table) table.removeEventListener("scroll", handleScroll);
        };
    }, []); // El efecto depende de `headerOffset`

    return (
        <th id={id} ref={elementRef} data-custom-width={customWidth || undefined} className={classes + (customWidth ? ` custom-width-${customWidth}` : "")}>
            {children}
        </th>
    );
};

export default CustomTh;
